import { Component, OnInit, Input, EventEmitter, Output, NgZone, OnDestroy } from "@angular/core";
import { EntityChildElement } from "../../model/EntityChildElement";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSmartModalService } from "ngx-smart-modal";
import { EntitiesService } from "app/private/entity/service/entities.service";
import { SxContextService } from "app/infrastructure/services/sxContext.service";
import { CategoryService } from "app/infrastructure/services/category.service";
import { Category } from "app/infrastructure/model/classes/category.class";
import { Categories } from "app/infrastructure/model/interfaces/categories.interface";

@Component({
  selector: "child-element",
  templateUrl: "./child-element.component.html",
  styleUrls: ["./child-element.component.css"]
})
export class ChildElementComponent implements OnInit, OnDestroy {

  private _entityChildlist: EntityChildElement[];

  @Input('entityChildlist') set entityChildlist(value: EntityChildElement[]) {
    this._entityChildlist = value;
    if (value !== undefined) {
      if (value.length > 0) {
        if ((this.auxiliaryChildList === null || this.auxiliaryChildList === undefined))
          this.auxiliaryChildList = value;
        if (this.childListWithoutFilter === undefined)
          this.childListWithoutFilter = this.entityChildlist;
      }
    }
  }
  get entityChildlist(): EntityChildElement[] {
    // other logic
    return this._entityChildlist;
  }
  auxiliaryChildList: EntityChildElement[] = undefined;

  @Input('title') title: string;
  @Output() entityOutPut = new EventEmitter<EntityChildElement>();
  childListWithoutFilter: EntityChildElement[];
  originalChildList: EntityChildElement[];

  childelementEmpty: EntityChildElement = {
    actions: [], categories: [], childs: [], context: { channelCode: '', organizationCode: '', productCode: '', subscriptionCode: '' },
    created: '', creationDate: null, descripcionExt: '', description: '', entityCode: '', entityType: '', route: '', title: ''
  };

  searchAtt: string = '';
  selectChild: number = 0;
  preventSingleClick = false;
  categories: Categories = { organizations: [], subscriptions: [], regions: [], countries: [] };
  context: {
    organizationCode: string
    subscriptionCode: string
    channelCode: string
    productCode: string
  }
  timer: any;
  delay: Number;

  constructor(
    private router: Router,
    private sxContext: SxContextService,
    private aRoute: ActivatedRoute,
    private entitiesService: EntitiesService,
    private _ngZone: NgZone,
    public ngxSmartModalService: NgxSmartModalService,
    private categoryservice: CategoryService
  ) { }

  ngOnInit(): void {

    this.sxContext.getContext(this.aRoute).subscribe(context => {
      this.context = context;
    })
  }

  sendParent(selectedItem: number, value: EntityChildElement) {
    this.preventSingleClick = false;
    this.timer = setTimeout(() => {
      this.selectChild = selectedItem;
      this.entityOutPut.emit(value);
    }, 300);
  }
  filteredCategories(value: Categories) {
    this.filterEntityChildList(value);
  }

  navegarNuevo() {
    if (this.context.channelCode != "" && this.context.channelCode != undefined) {
      this.router.navigate(["products/nuevo"], { relativeTo: this.aRoute });
    } else if (this.context.subscriptionCode != "" && this.context.subscriptionCode != undefined) {
      this.router.navigate(["channels/nuevo"], { relativeTo: this.aRoute });
    } else if (this.context.organizationCode != "" && this.context.organizationCode != undefined) {
      this.router.navigate(["subscriptions/nuevo"], { relativeTo: this.aRoute });
    }
    else{
      this.router.navigate(["nuevo"], { relativeTo: this.aRoute.parent });
    }
  }

  navigateToEntity(value: EntityChildElement) {
    this.preventSingleClick = true;
    clearTimeout(this.timer);
    this.router.navigate(["." + value.route], { relativeTo: this.aRoute });
  }

  filterAttr() {

    this.entityChildlist = this.childListWithoutFilter.filter(
      item =>
        item.description.toUpperCase().indexOf(this.searchAtt.toUpperCase()) !==
        -1
    );

    if (this.searchAtt === "") this.entityChildlist = this.childListWithoutFilter;
  }

  filterEntityChildList(filteredCategories: Categories) {

    if (this.originalChildList === undefined)
      this.originalChildList = this.entityChildlist;

    if (this.context.subscriptionCode === undefined && this.context.organizationCode !== undefined) {
      if (filteredCategories.subscriptions.filter(x => x.isSelected).length === filteredCategories.subscriptions.length)
        this.entityChildlist = this.auxiliaryChildList //if all category are select set inital child list
      else
        this.entityChildlist = this.originalChildList.filter(entity => entity.categories.
          some(c => filteredCategories.subscriptions.filter(s => s.isSelected === true).
            some(cate => cate.id === c)));

      this.childListWithoutFilter = this.entityChildlist;
    }
    if (this.context.organizationCode === undefined) {
      if (filteredCategories.organizations.filter(x => x.isSelected === true).length === filteredCategories.organizations.length)
        this.entityChildlist = this.auxiliaryChildList; //if all category are select set inital child list
      else
        this.entityChildlist = this.originalChildList.filter(entity => entity.categories.
          some(c => filteredCategories.organizations.filter(s => s.isSelected === true).
            some(cate => cate.id === c)));
      this.childListWithoutFilter = this.entityChildlist;
    }
    if (this.entityChildlist.length > 0)
      this.sendParent(0, this.entityChildlist[0]);
    else
      this.sendParent(0, this.childelementEmpty);
  }

  ngOnDestroy() {
    // this._ngZone.run(() => {
    // });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/main-entity-component/child-element/child-element.component.ts